const API_URL = 'https://password-manager-backend.khalnayak.workers.dev';
export async function login(password) {
  const response = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  if (!response.ok) throw new Error('Login failed');
  return response.json();
}

export async function getEntries() {
  const token = localStorage.getItem('sessionToken');
  const response = await fetch(`${API_URL}/entries`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Failed to fetch entries');
  return response.json();
}

export async function addEntry(entry) {
  const token = localStorage.getItem('sessionToken');
  const response = await fetch(`${API_URL}/entries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    body: JSON.stringify(entry),
  });
  if (!response.ok) throw new Error('Failed to add entry');
}

export async function deleteEntry(id) {
  const token = localStorage.getItem('sessionToken');
  const response = await fetch(`${API_URL}/entries/${id}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Failed to delete entry');
}